import styled from "@emotion/styled";
import { theme } from "../../lib/theme";

export const DesktopOnly = styled.div`
  flex: 1;
  min-height: 0;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileOnly = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    flex: 1;
    min-height: 0;
  }
`;

export const ResponsiveSvg = styled.svg`
  display: block;
  width: 100%;
  height: 100%;
`;

export const SnapshotWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  &:hover button {
    opacity: 1;
  }
`;

export const DownloadButton = styled.button`
  position: absolute;
  top: ${theme.spacing.sm};
  right: ${theme.spacing.sm};
  background: ${theme.colors.bg}cc;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.sm};
  padding: 4px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${theme.colors.bgHover};
  }
`;
